import { MeetingModel } from "@common/domain/models/Meeting";

import { IState } from "@store/webInterfaces";
import { ICreateMeeingDraftData } from "./interface";

const isEventStateUndefined = (state: IState) => state.event === undefined;

const isEventErrorsUndefined = (state: IState) => state.meeting.errors === undefined;

const isEventLoaderUndefined = (state: IState) => state.meeting.loaders === undefined;

// create event 
export const createEventSelector = (state: IState): MeetingModel | {} => {
    if(isEventStateUndefined(state) || !state.meeting.createEvent)
        return {};
    return state.meeting.createEvent;
}

export const createEventLoaderSelector = (state: IState): boolean => {
    if(isEventStateUndefined(state) || isEventLoaderUndefined(state) || !state.meeting.loaders.createEvent)
        return false;
    return state.meeting.loaders.createEvent;
}

export const createEventErrorSelector = (state: IState): string => {
    if(isEventStateUndefined(state) || isEventErrorsUndefined(state) || !state.meeting.errors.createEvent)
        return '';
    return state.meeting.errors.createEvent;
}

// event list
export const fetchEventListSelector = (state: IState): MeetingModel[] => {
    if(isEventStateUndefined(state) || !state.meeting.fetchEventList)
        return [];
    return state.meeting.fetchEventList;
}

export const fetchEventListLoaderSelector = (state: IState): boolean => {
    if(isEventStateUndefined(state) || isEventLoaderUndefined(state) || !state.meeting.loaders.fetchEventList)
        return false;
    return state.meeting.loaders.fetchEventList;
}

export const fetchEventListErrorSelector = (state: IState): string => {
    if(isEventStateUndefined(state) || isEventErrorsUndefined(state) || !state.meeting.errors.fetchEventList)
        return '';
    return state.meeting.errors.fetchEventList;
}

// event detail
export const fetchEventDetailSelector = (state: IState): MeetingModel => {
    if(isEventStateUndefined(state) || !state.meeting.eventDetail)
        return null;
    return state.meeting.eventDetail;
}

export const fetchEventDetailLoaderSelector = (state: IState): boolean => {
    if(isEventStateUndefined(state) || isEventLoaderUndefined(state) || !state.meeting.loaders.eventDetail)
        return false;
    return state.meeting.loaders.eventDetail;
}

export const fetchEventDetailErrorSelector = (state: IState): string => {
    if(isEventStateUndefined(state) || isEventErrorsUndefined(state) || !state.meeting.errors.eventDetail)
        return '';
    return state.meeting.errors.eventDetail;
}

// delete event
export const deleteEventSelector = (state: IState): MeetingModel => {
    if(isEventStateUndefined(state) || !state.meeting.deletedEvent)
        return null;
    return state.meeting.deletedEvent;
}

export const deleteEventLoaderSelector = (state: IState): boolean => {
    if(isEventStateUndefined(state) || isEventLoaderUndefined(state) || !state.meeting.loaders.deletedEvent)
        return false;
    return state.meeting.loaders.deletedEvent;
}

export const deleteEventErrorSelector = (state: IState): string => {
    if(isEventStateUndefined(state) || isEventErrorsUndefined(state) || !state.meeting.errors.deletedEvent)
        return '';
    return state.meeting.errors.deletedEvent;
}

export const updateMeetLoaderSelector = (state: IState) => state?.meeting?.loaders?.updateMeeting || false;

export const updateMeetErrorSelector = (state: IState) => state?.meeting?.errors?.updateMeeting || '';

export const getCreateMeetingDraftData  =(state:IState):ICreateMeeingDraftData=> state?.meeting?.meetingDetailDraft || {};

export const fetchCourseMeetingListSelector = (state: IState) => state?.meeting?.courseMeetingList || [];
export const fetchCourseMeetingListLoaderSelector = (state: IState) => state?.meeting?.loaders?.courseMeetingList || false;
export const fetchCourseMeetingListErrorSelector = (state: IState) => state?.meeting?.errors?.courseMeetingList || "";

export const attendeeMeetingEnrollSelector = (state: IState) => state?.meeting?.attendeeMeetingEnroll || [];
export const attendeeMeetingEnrollLoaderSelector = (state: IState) => state?.meeting?.loaders?.attendeeMeetingEnroll || false;
export const attendeeMeetingEnrollErrorSelector = (state: IState) => state?.meeting?.errors?.attendeeMeetingEnroll || "";

export const fetchLessonMeetingListSelector = (state: IState) => state?.meeting?.lessonMeetingList || [];
export const fetchLessonMeetingListLoaderSelector = (state: IState) => state?.meeting?.loaders?.lessonMeetingList || false;
export const fetchLessonMeetingListErrorSelector = (state: IState) => state?.meeting?.errors?.lessonMeetingList || "";

export const slotBookingLoaderSelector = (state: IState) => state?.meeting?.loaders?.slotBooking || false;
export const slotBookingErrorSelector = (state: IState) => state?.meeting?.errors?.slotBooking || '';
export const slotBookingSelector = (state: IState) => state?.meeting?.slotBooking || null;
